import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { statusMessages } from './messages'
import { STATUS } from './constants'

export const getStatusColor = (status: TSFixMe): TSFixMe => {
  switch (status) {
    case STATUS.STARTED:
      return '#5ebbb5'
    case STATUS.COMPLETED:
      return '#5d5c70'
    case STATUS.CANCELLED:
      return '#e74646'
    case STATUS.SCHEDULED:
      return '#64bb5e'
  }
}

const Status = styled.div<TSFixMe>`
  color: ${(props): TSFixMe => getStatusColor(props.status)};
`

export const ChangeStatus = ({ status }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  if (statusMessages[status]) {
    return <Status status={status}>{intl.formatMessage(statusMessages[status])}</Status>
  }

  return <div>{status}</div>
}
